import React from "react";
import ConteudoEsquerda from "./AuthCommon/ConteudoEsquerda";
import FormWrapper from "./AuthCommon/FormWrapper";
import CommonInput from "../../components/forms/CommonInput";
import { AppContext } from "../../contexts/AppContext";
import { handleChange } from "../../helpers/handleFormChanges";
import AuthApiClient from "../../api/auth";
import useApi from "../../hooks/useApi";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";

function RedefinirSenha() {
  const { baseUrl } = React.useContext(AppContext);
  const [values, setValues] = React.useState({});

  const recuperarSenhaApi = useApi(AuthApiClient.recuperarSenha);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("email", values?.email);

    if (
      Validation.verificarForm(formData) ||
      Validation.validarEmail(values?.email)
    )
      return ErrorSwal({
        text: "Favor informar um e-mail válido.",
      });

    const response = await recuperarSenhaApi.request(formData);
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "E-mail enviado com Sucesso!",
      text: "Se o seu e-mail estiver cadastrado em nosso sistema, você receberá um e-mail de recuperação de senha em breve. Por favor, verifique sua caixa de entrada e a caixa de spam.",
    }).then((result) => {
      if (result.isConfirmed) window.location.href = `${baseUrl}login`;
    });
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <ConteudoEsquerda />
          <FormWrapper>
            <div>
              <h5 className="first-text">Redefinir senha</h5>
              <h6 className="second-text mb-3">
                Digite seu e-mail e as instruções serão enviadas!
              </h6>
            </div>
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <CommonInput
                    label="E-mail"
                    id="email"
                    value={values.email}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    placeholder="Digite seu e-mail"
                    auth
                  />
                </div>
                <div className="mt-3 mb-3 d-grid right-footer">
                  <button
                    className="btn btn-primary waves-effect waves-light auth-button"
                    type="submit"
                  >
                    Redefinir
                  </button>
                </div>
                <div className="mt-3 mb-3 d-grid">
                  <button
                    id="sairSistemaEmpresas"
                    className="btn btn-primary waves-effect waves-light auth-button-red"
                    type="button"
                    onClick={() => {
                      window.location.href = `${baseUrl}login`;
                    }}
                  >
                    Voltar
                  </button>
                </div>
              </form>
            </div>
          </FormWrapper>
        </div>
      </div>
    </>
  );
}

export default RedefinirSenha;
